import { useAuth0 } from '@auth0/auth0-react';
import { FunctionComponent, memo, useEffect } from 'react';
import { useReactiveVar } from '@apollo/client/react/hooks/useReactiveVar';

/**
 * Packages
 */
import { PageLoader } from '@astrumu/ui-library';

/**
 * Reactive Variable
 */
import {
  CurrentUser,
  currentUserVar,
  isLoggedInVar
} from '@/apollo/cache/variables';

/**
 * Types
 */
import { Auth0User } from '@/lib/types';

interface Props {
  children: (props: { currentUser: CurrentUser }) => JSX.Element | null;
}

export const UserProvider: FunctionComponent<Props> = memo(({ children }) => {
  const { user, isAuthenticated } = useAuth0<Auth0User>();

  const currentUser = useReactiveVar(currentUserVar);

  useEffect(() => {
    if (user && isAuthenticated) {
      isLoggedInVar(true);

      currentUserVar({
        email: user.email,
        userId: user.sub,
        fullName: user.name,
        firstName: user.given_name || user.firstName,
        lastName: user.family_name || user.lastName
      });
    }
  }, [isAuthenticated, user]);

  if (isAuthenticated) {
    if (currentUser?.userId) {
      return <>{children({ currentUser })}</>;
    }

    return <PageLoader />;
  }

  return (
    <>
      {children({
        currentUser: {
          email: '',
          userId: '',
          fullName: '',
          firstName: '',
          lastName: ''
        }
      })}
    </>
  );
});
